var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 458,
    viewBox: "0 0 814 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "#879196"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 734,
    height: 418,
    fill: "#D5D8DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 714,
    height: 408,
    fill: "#80BDE0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 217,
    width: 666,
    height: 32,
    rx: 8,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 219,
    width: 300,
    height: 28,
    rx: 8,
    fill: "#4DA3D4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 419,
    y: 279,
    width: 321,
    height: 32,
    rx: 8,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 419.964,
    y: 281,
    width: 192.793,
    height: 28,
    rx: 8,
    fill: "#268FCA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 279,
    width: 321,
    height: 32,
    rx: 8,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 74.964,
    y: 281,
    width: 192.793,
    height: 28,
    rx: 8,
    fill: "#007BC1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 341,
    width: 220,
    height: 32,
    rx: 8,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 74.6607,
    y: 343,
    width: 66.0661,
    height: 28,
    rx: 8,
    fill: "#0073BB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 341,
    width: 422,
    height: 32,
    rx: 8,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 319.267,
    y: 343,
    width: 126.727,
    height: 28,
    rx: 8,
    fill: "#007BC1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 403,
    width: 666,
    height: 32,
    rx: 8,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 405,
    width: 550,
    height: 28,
    rx: 8,
    fill: "#005EAB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193 133.5C193 121.732 189.51 110.228 182.972 100.444C176.434 90.6588 167.142 83.0326 156.27 78.5292C145.397 74.0258 133.434 72.8475 121.892 75.1433C110.35 77.4391 99.7484 83.1059 91.4271 91.4271C83.1059 99.7484 77.4391 110.35 75.1433 121.892C72.8475 133.434 74.0258 145.397 78.5292 156.27C83.0326 167.142 90.6588 176.435 100.444 182.972C110.228 189.51 121.732 193 133.5 193V175.15C125.262 175.15 117.21 172.707 110.361 168.131C103.511 163.554 98.1728 157.049 95.0204 149.439C91.868 141.828 91.0432 133.454 92.6503 125.374C94.2574 117.295 98.2241 109.874 104.049 104.049C109.874 98.2241 117.295 94.2574 125.374 92.6503C133.454 91.0432 141.828 91.868 149.439 95.0204C157.049 98.1728 163.554 103.511 168.131 110.361C172.707 117.21 175.15 125.262 175.15 133.5H193Z",
    fill: "#4DA3D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8498 172.827C96.6279 181.658 106.85 187.984 118.224 191.005C129.597 194.027 141.611 193.608 152.746 189.801C163.882 185.995 173.638 178.971 180.782 169.62C187.926 160.268 192.136 149.009 192.881 137.264C193.625 125.52 190.87 113.818 184.965 103.64C179.059 93.4608 170.267 85.2619 159.702 80.0797C149.136 74.8975 137.271 72.9648 125.607 74.5258C113.943 76.0869 103.004 81.0717 94.173 88.8498L105.971 102.245C112.153 96.8002 119.81 93.3108 127.975 92.2181C136.14 91.1253 144.445 92.4783 151.841 96.1058C159.237 99.7334 165.391 105.473 169.525 112.598C173.659 119.723 175.588 127.914 175.067 136.135C174.545 144.356 171.598 152.238 166.597 158.784C161.597 165.33 154.767 170.246 146.973 172.911C139.178 175.575 130.768 175.869 122.807 173.754C114.845 171.639 107.69 167.211 102.245 161.029L88.8498 172.827Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M375 133.5C375 121.226 371.204 109.253 364.133 99.2204C357.062 89.1882 347.061 81.5884 335.501 77.4625C323.941 73.3366 311.389 72.8865 299.563 76.174C287.738 79.4615 277.219 86.3256 269.447 95.8256C261.675 105.326 257.032 116.997 256.153 129.239C255.274 141.481 258.202 153.696 264.537 164.209C270.872 174.722 280.303 183.018 291.537 187.961C302.772 192.904 315.26 194.252 327.29 191.82L323.753 174.324C315.332 176.027 306.59 175.083 298.726 171.623C290.862 168.163 284.26 162.355 279.826 154.996C275.392 147.637 273.342 139.087 273.957 130.517C274.572 121.948 277.823 113.778 283.263 107.128C288.703 100.478 296.067 95.673 304.344 93.3718C312.622 91.0706 321.409 91.3856 329.501 94.2737C337.593 97.1619 344.593 102.482 349.543 109.504C354.493 116.527 357.15 124.908 357.15 133.5H375Z",
    fill: "#268FCA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M259.889 154.659C263.189 163.332 268.472 171.113 275.316 177.381C282.16 183.648 290.374 188.227 299.304 190.753C308.233 193.279 317.629 193.682 326.742 191.928C335.855 190.175 344.431 186.315 351.785 180.656C359.14 174.996 365.068 167.696 369.098 159.336C373.127 150.977 375.146 141.791 374.992 132.513C374.838 123.234 372.516 114.121 368.211 105.9C363.907 97.6788 357.739 90.5787 350.201 85.1667L339.791 99.6667C345.067 103.455 349.385 108.425 352.398 114.18C355.411 119.934 357.036 126.314 357.144 132.809C357.252 139.304 355.839 145.734 353.019 151.585C350.198 157.437 346.048 162.547 340.9 166.509C335.751 170.47 329.748 173.173 323.369 174.4C316.991 175.627 310.413 175.345 304.163 173.577C297.912 171.809 292.162 168.603 287.371 164.216C282.581 159.829 278.883 154.383 276.573 148.311L259.889 154.659Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M557 133.5C557 166.361 530.361 193 497.5 193C464.639 193 438 166.361 438 133.5C438 100.639 464.639 74 497.5 74C530.361 74 557 100.639 557 133.5ZM455.85 133.5C455.85 156.503 474.497 175.15 497.5 175.15C520.503 175.15 539.15 156.503 539.15 133.5C539.15 110.497 520.503 91.85 497.5 91.85C474.497 91.85 455.85 110.497 455.85 133.5Z",
    fill: "#007BC1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M551.818 109.214C546.538 97.4058 537.555 87.6396 526.228 81.3945C514.9 75.1495 501.847 72.7656 489.043 74.604C476.24 76.4425 464.384 82.403 455.272 91.583C446.159 100.763 440.287 112.662 438.543 125.479L456.23 127.885C457.451 118.914 461.562 110.584 467.94 104.158C474.319 97.7321 482.618 93.5597 491.58 92.2728C500.543 90.9859 509.68 92.6546 517.609 97.0262C525.538 101.398 531.827 108.234 535.523 116.5L551.818 109.214Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M739 133.5C739 166.361 712.361 193 679.5 193C646.639 193 620 166.361 620 133.5C620 100.639 646.639 74 679.5 74C712.361 74 739 100.639 739 133.5ZM637.85 133.5C637.85 156.503 656.497 175.15 679.5 175.15C702.503 175.15 721.15 156.503 721.15 133.5C721.15 110.497 702.503 91.85 679.5 91.85C656.497 91.85 637.85 110.497 637.85 133.5Z",
    fill: "#005EAB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M661.775 190.299C672.907 193.772 684.814 193.899 696.016 190.662C707.219 187.425 717.224 180.967 724.787 172.092L711.201 160.514C705.906 166.727 698.903 171.247 691.061 173.513C683.219 175.779 674.885 175.691 667.093 173.259L661.775 190.299Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingBanner);
export default __webpack_public_path__ + "static/media/loading-banner.ba9dc025655104466250039fd4b1e8a1.svg";
export { ForwardRef as ReactComponent };